import { createContext } from 'react';
import type { StationData } from '../../api/stationObservationsService';

export interface StationObservationsContextValue {
  stations: StationData[];
  loading: boolean;
  error: string | null;
  /** True when at least one dashboard widget currently requires station observations */
  needsObservations: boolean;
}

export const StationObservationsCtx =
  createContext<StationObservationsContextValue | null>(null);
